import PropTypes from 'prop-types';
import React from 'react';
import { POST_CODE_MAX_LENGTH } from '../../brands/default/constants';
import { LOOKUP_VERIFY_POSTCODE } from '../../brands/default/content/components/address';
import FormikInput from '../_generic/input/FormikInput';

const LookupVerifyPostcode = ({
  onChangeFunction,
  onBlurFunction,
  values,
  errors,
  touched,
  extraClasses = '',
  disabled = false,
}) => {
  const setInputField = (event) => {
    if (event.target.value.length > POST_CODE_MAX_LENGTH) {
      event.target.value = event.target.value.slice(0, POST_CODE_MAX_LENGTH);
    }
    onChangeFunction(event);
  };

  return (
    <>
      <div className="col-12 col-md-6">
        <FormikInput
          dataqa="postCode"
          disabled={disabled}
          errorText={errors.postCode}
          extraClasses={extraClasses}
          inputError={errors.postCode}
          inputTouched={touched.postCode}
          inputValue={values.postCode}
          maxLength={POST_CODE_MAX_LENGTH}
          name={'postCode'}
          onBlurFunction={onBlurFunction}
          onChangeFunction={setInputField}
          placeholder={LOOKUP_VERIFY_POSTCODE.registrationAddress}
          type="text"
        />
      </div>
    </>
  );
};

LookupVerifyPostcode.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.object.isRequired,
  extraClasses: PropTypes.string,
  onBlurFunction: PropTypes.func.isRequired,
  onChangeFunction: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};

export default LookupVerifyPostcode;
